module.exports = __webpack_public_path__ + "img/c02_unitspearmanchampion_Normal_ua.98a1842d.webp";